/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled, { css } from 'styled-components';
import { Heading } from '@99designs/emu';
import { COLOR } from './constants';

interface HeaderProps {
    title: string;
    displayIndex: number;
    link: string;
    image: Record<string, any>;
    video: Record<string, any>;
}

const Header = (props: HeaderProps) => {
    return (
        <StyledHeader link={props.link} image={props.image} video={props.video}>
            {(props.displayIndex || (props.link && (props.image || props.video))) && (
                <div className={'tile__index'}>{props.displayIndex}</div>
            )}
            {props.title && (
                <Heading
                    className={'tile__title'}
                    appearanceLevel={4}
                    accessibilityLevel={7}
                    as="p"
                >
                    {props.title}
                </Heading>
            )}
        </StyledHeader>
    );
};

export default Header;

const StyledHeader = styled.div<{
    link: string;
    image: Record<string, any>;
    video: Record<string, any>;
}>`
    position: relative;
    display: flex;
    z-index: 2;

    .tile__index {
        width: 75px;
        height: 75px;
        background: ${COLOR.BLACK};
        color: ${COLOR.WHITE};
        font-size: 2.5rem;
        display: flex;
        justify-content: center;
        font-weight: bold;
        line-height: 75px;
        flex-shrink: 0;
    }

    .tile__title {
        width: 100%;
        font-weight: bold;
        padding: 15px 15px 0;
        color: ${COLOR.WHITE};

        ${(props) =>
            props.link &&
            (props.image || props.video) &&
            css`
                background: rgba(35, 35, 35, 0.9);
                opacity: 0;
                transition: opacity 300ms cubic-bezier(0.19, 1, 0.22, 1);
            `}
    }
`;
